import m from "./ghl-ui.es1505.js";
import a from "./ghl-ui.es1506.js";
import i from "./ghl-ui.es1466.js";
function d(t, r) {
  i(2, arguments);
  var e = a(t).getTime(), o = m(r);
  return new Date(e + o);
}
export {
  d as default
};
